<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <SearchTitle label='带教老师月度奖金发放报表' url='/report/achievement/tec'></SearchTitle>
      <div class="m-portlet__body">
        <div class="m-form m-form--label-align-right">
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">管理单元：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.secretarysec" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in managesecOptions" :key="item.DictItemID" :label="item.DictItemName" :value="item.DictItemID">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <SearchNormalText v-model='condition.truename' label='姓名'></SearchNormalText>
          <SearchNormalText v-model='condition.cardno' label='工号'></SearchNormalText>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">考核月份：</label>
              </div>
              <div class="m-form__control">
                <el-date-picker v-model="condition.assessmentmonth" type="month" placeholder="考核月份" value-format="yyyy-MM">
                </el-date-picker>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
          <el-button type="primary" icon="el-icon-search" @click="TeachSearch(1)">查询</el-button>
          <el-button type="primary" icon="el-icon-download" @click="OutTypeSelect()">导出</el-button>
          <el-button type="primary" icon="el-icon-download" @click="TeachInfoOut">带教详细导出</el-button>
          <el-button type="primary" icon="el-icon-search" @click="TecCompare">发放比较</el-button>
        </div>
        <!--end: Search Form -->
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <!--begin: Datatable -->
          <div v-html="tabTeachAchievement">
          </div>
          <div style="margin-top: 10px;text-align: center;">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="condition.currentPage"
              :page-sizes="[2, 10, 20, 30, 40]" :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="condition.recordCount">
            </el-pagination>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
    <el-dialog title="选择导出格式" :visible.sync="dialogOutTypeVisible" width="400px">
      <el-row>
        <el-col :span="6" style="text-align: right;">格式：</el-col>
        <el-col :span="18" style="padding-left: 5px;">
          <el-radio v-model="condition.outtype" label="1">PDF</el-radio>
          <el-radio v-model="condition.outtype" label="2">Excel</el-radio>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="Out()" v-loading.fullscreen.lock="fullscreenLoading">导 出</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        condition: {
          token: '',
          truename: '',
          sec: '',
          cardno: '',
          assessmentmonth: '',
          pageSize: 10,
          currentPage: 1,
          recordCount: 0,
          firstSearch: true,
          secretarysec: '',
          outtype: '1'
        },
        tabTeachAchievement: null,
        secOptions: [],
        managesecOptions: [],
        dialogOutTypeVisible: false,
        fullscreenLoading: false
      }
    },
    methods: {
      TecCompare:function(){
          this.$router.push({
            name: 'AchievementTecCompare'
          })
      },
      OutTypeSelect: function() {
        this.dialogOutTypeVisible = true
      },
      Out: function() {
        this.TeachOut()
      },
      // 调整每页显示数
      handleCurrentChange: function(val) {
        this.condition.firstSearch = false
        this.condition.currentPage = val
        this.TeachSearch()
      },
      // 分页操作
      handleSizeChange: function(val) {
        this.condition.firstSearch = false
        this.condition.pageSize = val
        this.condition.currentPage = 1
        this.TeachSearch()
      },
      TeachSearch: function(index) {
        if (index != null) {
          this.condition.currentPage = 1
        }
        this.$http.post(this.$utils.Url.zpgl + '/api/APIMoneyGrant/TeachReportList', this.condition)
          .then(res => {
            if (res.data.Code === 0) {
              var results = res.data.Data.split('|')
              this.tabTeachAchievement = results[0]
              this.condition.recordCount = Number(results[1])
            } else {
              this.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
          })
          .catch(err => {
            this.tabTeachAchievement = null
            console.log(err)
            this.$message({
              message: '查询失败',
              type: 'error'
            })
          })
      },
      TeachOut: function() {
        this.$http.post(this.$utils.Url.zpgl + '/api/APIMoneyGrant/TeachReportListOut', this.condition)
          .then(res => {
            if (res.data.Code === 0) {
              var filename = res.data.Data
              var url = ''
              if (this.condition.outtype == 1) {
                url = this.$utils.Url.zpgl + '/pdf/' + filename
              } else {
                url = this.$utils.Url.zpgl + '/doc/' + filename
              }
              window.open(url)
            }
          })
          .catch(err => {
            console.log(err)
            this.$message({
              message: '导出失败',
              type: 'error'
            })
          })
      },
      TeachInfoOut: function() {
        this.$http.post(this.$utils.Url.zpgl + '/api/APIMoneyGrant/TeachInfoReportListOut', this.condition)
          .then(res => {
            if (res.data.Code === 0) {
              var filename = res.data.Data
              var url = this.$utils.Url.zpgl + '/doc/' + filename
              window.open(url)
            }
          })
          .catch(err => {
            console.log(err)
            this.$message({
              message: '导出失败',
              type: 'error'
            })
          })
      },
      LoadManageSec: function() {
        var args = {
          token: this.condition.token,
          username: this.condition.username,
          rolelevel: this.condition.rolelevel
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/ManageSecionList', args, function(data) {
          that.managesecOptions = data.Data
        }, null, null, null)
      }
    },
    mounted: function() {
      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      this.condition.assessmentmonth = year + '-' + month
      this.condition.token = sessionStorage.getItem('token')
      this.condition.username = sessionStorage.getItem('username')
      this.condition.rolelevel = sessionStorage.getItem('rolelevel')
      this.LoadManageSec()
      this.TeachSearch()
    }
  }
</script>

<style scoped="scoped">
  /deep/.el-input {
    width: 220px;
  }
</style>

<style scoped="scoped">
  @import '../../../assets/css/achievementinfo.css'
</style>
